$(document).ready(function() {
  $("body").tooltip({
    selector: "[rel=tooltip]"
  });

  $("a[data-toggle=popover]").popover({
    html: true
  });

});